import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { showModal, hideModal } from './modalAction'

export default function withReduxModal(WrappedComponent) {
  return connect(
    ({ modal }) => ({ modal }),
    dispatch => ({
      modalActions: bindActionCreators(
        { showModal: showModal, hideModal: hideModal },
        dispatch,
      ),
    }),
  )(WrappedComponent)
}

export const modalPropTypes = {
  modalActions: PropTypes.shape({
    showModal: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired,
  }),
  modal: PropTypes.object.isRequired,
}



// WEBPACK FOOTER //
// ./src/modules/redux-modal/redux/withReduxModal.js